import React, { useState, useEffect } from 'react';
import './WordDisplay.css';

function WordDisplay({ word, isLoading, onNewWord }) {
  const [displayWord, setDisplayWord] = useState(word);
  const [isFlipping, setIsFlipping] = useState(false);

  useEffect(() => {
    if (word !== displayWord && !isLoading && word) {
      // Start the flip animation
      setIsFlipping(true);

      // After the flip-out animation completes, update the word and flip back in
      setTimeout(() => {
        setDisplayWord(word);
      }, 300); // Half of the total animation duration

      // End the flipping state after the full animation
      setTimeout(() => {
        setIsFlipping(false);
      }, 600); // Full animation duration
    }
  }, [word, displayWord, isLoading]);

  // Initialize displayWord when component first loads
  useEffect(() => {
    if (word && !displayWord) {
      setDisplayWord(word);
    }
  }, [word, displayWord]);

  return (
    <div className="word-display">
      <div className="word-card">
        <div className="word-container">
          <div className={`word-wrapper ${isFlipping ? 'flipping' : ''}`}>
            <h2 className="word">{displayWord}</h2>
          </div>
        </div>
      </div>
      <button
        className="new-word-btn"
        onClick={onNewWord}
        disabled={isLoading}
      >
        {isLoading ? 'Loading...' : 'New Word'}
      </button>
    </div>
  );
}

export default WordDisplay;